import { j as e } from "../../_virtual/jsx-runtime.js";
const l = ({
  width: C = 20,
  height: o = 20,
  viewBox: t = "0 0 20 20",
  fill: s = "currentColor",
  ...n
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    width: C,
    height: o,
    viewBox: t,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.83331 16.7906C13.3679 16.7906 16.2333 13.9252 16.2333 10.3906C16.2333 6.856 13.3679 3.99063 9.83331 3.99063C6.29869 3.99063 3.43331 6.856 3.43331 10.3906C3.43331 13.9252 6.29869 16.7906 9.83331 16.7906ZM9.83331 18.3906C14.2516 18.3906 17.8333 14.8089 17.8333 10.3906C17.8333 5.97235 14.2516 2.39062 9.83331 2.39062C5.41504 2.39062 1.83331 5.97235 1.83331 10.3906C1.83331 14.8089 5.41504 18.3906 9.83331 18.3906Z",
          fill: s
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M10.0265 8.11335C10.7737 7.37159 11.9851 7.37159 12.7323 8.11335C13.4794 8.85508 13.4794 10.0577 12.7323 10.7994L9.83329 13.6774L6.93431 10.7994C6.18715 10.0577 6.18715 8.85508 6.93431 8.11335C7.68148 7.37159 8.89289 7.37159 9.64005 8.11335L9.83308 8.30483L10.0265 8.11335Z",
          fill: s
        }
      )
    ]
  }
);
export {
  l as default
};
